import Service from "../../../Services/index";

const productModule = {
    namespaced: true,
    state: {
        data: [],
        pack : [],
        product_all : [],
        validate_product : "",
        search:{
            code : "",
            type : ""
        },
        ProductForm :{
            name: "",
            short_name : "",
            code: "",
            price: 0.00,
            quantity: 0,
            min_quantity: 0,
            unit_quantity : null,
            product_type: null,
            pack : null,
            machine : null,
            employee_id : "",
            quantity_pack : "",
            size_form_id : null,
            special_product : null,
            onSave: false,
            material : null,
            commission : '',
        },
    },
    mutations: {
        GET_PRODUCT_ALL:(state,data)=>{
          state.product_all = data;
        },
        SET_DATA_FORM: (state, res) => {
            state.ProductForm = res;
            state.ProductForm.onSave = false;
        },
        CLEAR_FORM_DATA: state => {
            state.ProductForm = {
                name: "",
                short_name : "",
                code: "",
                price: 0.00,
                quantity: 0,
                min_quantity: 0,
                product_type: null,
                unit_quantity : null,
                pack : null,
                machine : null,
                employee_id : "",
                quantity_pack : "",
                size_form_id : null,
                special_product : null,
                onSave: false,
                material : null,
                commission : '',
            };
        },
        GET_PACK:(state, res) => {
            state.pack = res;
        },
        VALIDATE_DUPLICATE_PRODUCT:(state,res)=>{
            state.validate_product = res;
        },
        CLEAR_SEARCH :(state)=> {
            state.search = {
                code: "",
                type: ""
            }
        }
    },
    actions: {
        setProducts({ commit },page=1) {
            return Service.products.getProduct(page);
        },
        getProductAll({commit}){
          return Service.products.getProductAll().then(res=>{
              commit("GET_PRODUCT_ALL",res);
          })
        },
        show({ commit }, id) {
            return Service.products.showProduct(id).then(response => {
                commit("SET_DATA_FORM", response);
            });
        },
        save({ commit,state },{id,user} ){
            console.log(id);
            if(!state.ProductForm.quantity){
                state.ProductForm.quantity = 0
            }
            const data = {
                name: state.ProductForm.name,
                short_name : state.ProductForm.short_name,
                product_type_id: state.ProductForm.product_type.id,
                unit_quantity : state.ProductForm.unit_quantity,
                pack_id : "",
                code: state.ProductForm.code,
                price: state.ProductForm.price,
                quantity: state.ProductForm.quantity,
                min_quantity: state.ProductForm.min_quantity,
                quantity_pack : state.ProductForm.quantity_pack,
                size_form_id  : state.ProductForm.size_form_id,
                special_product : state.ProductForm.special_product,
                commission : state.ProductForm.commission,
                material_id : state.ProductForm.material ? state.ProductForm.material.id : null,
            };
            if(state.ProductForm.pack!==null){
                data.pack_id = state.ProductForm.pack.id
            }
            console.log(data);
            if(!id){//create
                return Service.products.createProduct(data).then(response=>{
                    commit("VALIDATE_DUPLICATE_PRODUCT",response);
                    console.log(response);
                });
            }
            else{ //update
                return Service.products.updateProduct(id, data).then(response=>{
                    commit("VALIDATE_DUPLICATE_PRODUCT",response);
                    console.log(response);
                });
            }
        },
        delete({ commit }, id) {
            return Service.products.deleteProduct(id)
        },
        search({ commit }, {page, code, type }) {
            return Service.products.searchProduct(page,code, type);
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        getPack({commit}){
            return Service.products.getPackProduct().then(response=>{
                commit('GET_PACK',response);
            })
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },
        updatePriceProduct({commit},data){
            return Service.products.updatePriceProduct(data);
        },
        updateCommissionProduct({commit},data){
            return Service.products.updateCommissionProduct(data);
        },
    }
};

export default productModule;
